import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFormCheckQqSelected = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter0_i)",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 12,
				height: 12,
				rx: 3,
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 1,
			y: 1,
			width: 10,
			height: 10,
			rx: 2,
			stroke: "#31AF19",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M9.61452 4.0002C9.70484 4.0927 9.75 4.20502 9.75 4.33717C9.75 4.46932 9.70484 4.58164 9.61452 4.67414L5.45323 8.93584C5.3629 9.02835 5.25323 9.0746 5.12419 9.0746C4.99516 9.0746 4.88548 9.02835 4.79516 8.93584L2.38548 6.46802C2.29516 6.37552 2.25 6.2632 2.25 6.13105C2.25 5.9989 2.29516 5.88658 2.38548 5.79408L3.04355 5.12013C3.13387 5.02763 3.24355 4.98138 3.37258 4.98138C3.50161 4.98138 3.61129 5.02763 3.70161 5.12013L5.12419 6.582L8.29839 3.32625C8.38871 3.23375 8.49839 3.1875 8.62742 3.1875C8.75645 3.1875 8.86613 3.23375 8.95645 3.32625L9.61452 4.0002Z",
			fill: "#31AF19"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("filter", {
			id: "filter0_i",
			x: 0,
			y: 0,
			width: 12,
			height: 12,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "BackgroundImageFix",
					result: "shape"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", {}),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 2.5 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "arithmetic",
					k2: -1,
					k3: 1
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "shape",
					result: "effect1_innerShadow"
				})
			]
		}) })
	]
});
const ForwardRef = forwardRef(SvgFormCheckQqSelected);
export { ForwardRef as ReactComponent };
